import React from 'react';

const IndexPage = () => {
  return (
    <div className="w-10/12 mx-auto my-10">
      <h1>Ceritanya Landing Page</h1>

      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Tempore saepe,
        corporis impedit illo maiores architecto. Rerum cumque, dolores
        necessitatibus voluptate itaque, ab soluta non expedita temporibus amet
        vitae, animi minima?
      </p>
    </div>
  );
};

export default IndexPage;
